import { Channel } from '../types';

export interface ChannelSections {
  selfChannel: Channel | undefined;
  mainChannels: Channel[];
  groupChannels: Channel[];
  dmChannels: Channel[];
}

/**
 * 채널 목록을 사이드바/모바일 목록 공용 섹션으로 분류·정렬한다.
 *
 * - 계열사 가시성 가드 (defense-in-depth: 서버 가드가 우회되어도 클라이언트에서 차단)
 *   public 채널: affiliateId가 NULL이거나 사용자 계열사와 일치할 때만 표시.
 *   public 외(private/group/dm): 멤버십이 이미 보장되므로 그대로 표시
 * - 아카이브된 채널은 항상 제외 (state가 stale해도 렌더링 차단)
 * - 고정 채널을 섹션 내 최상단으로 (고정끼리는 최근 고정 순). 안정 정렬이라 비고정은 서버 순서 유지
 */
export function classifyChannels(rawChannels: Channel[], userAffiliateId?: string | null): ChannelSections {
  let self: Channel | undefined;
  const main: Channel[] = [];
  const groups: Channel[] = [];
  const dms: Channel[] = [];
  for (const ch of rawChannels) {
    if (ch.isArchived) continue;
    if (ch.type === 'public' && ch.affiliateId != null && ch.affiliateId !== userAffiliateId) continue;
    if (ch.type === 'self') self = ch;
    else if (ch.type === 'public' || ch.type === 'private') main.push(ch);
    else if (ch.type === 'group') groups.push(ch);
    else if (ch.type === 'dm') dms.push(ch);
  }
  const byPin = (a: Channel, b: Channel) =>
    Number(b.isPinned ?? false) - Number(a.isPinned ?? false)
    || (b.pinnedAt ? Date.parse(b.pinnedAt) : 0) - (a.pinnedAt ? Date.parse(a.pinnedAt) : 0);
  main.sort(byPin);
  groups.sort(byPin);
  dms.sort(byPin);
  return { selfChannel: self, mainChannels: main, groupChannels: groups, dmChannels: dms };
}
